var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as _ from 'lodash';
import { Component, ViewChild, Input } from '@angular/core';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
var EllipseSettingModalComponent = /** @class */ (function (_super) {
    __extends(EllipseSettingModalComponent, _super);
    function EllipseSettingModalComponent(injector) {
        return _super.call(this, injector, 'ellipseSettingModal') || this;
    }
    EllipseSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        var model = editedComponent.model.data;
        this.fill = model.fill ? model.fill : '#ffffff';
        this.stroke = model.stroke ? model.stroke : '#333';
        this.strokeWidth = model.strokeWidth;
        this.width = model.width ? model.width : 80;
        this.height = model.height ? model.height : 80;
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.loadDynamicSetting(editedComponent.model.data);
    };
    EllipseSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    EllipseSettingModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('ellipse settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(2);
            return;
        }
        this.saveComponentProperty('fill', this.fill);
        this.saveComponentProperty('stroke', this.stroke);
        this.saveComponentProperty('strokeWidth', this.strokeWidth);
        this.saveComponentProperty('width', this.width);
        this.saveComponentProperty('height', this.height);
        this.saveDynamicSetting();
        this.currentDiagram.commitTransaction('ellipse settings');
        this.close();
    };
    EllipseSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    EllipseSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    EllipseSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    EllipseSettingModalComponent.prototype.setStrokeColor = function (color) {
        this.stroke = color;
    };
    EllipseSettingModalComponent.prototype.setFillColor = function (color) {
        this.fill = color;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], EllipseSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], EllipseSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        Input()
    ], EllipseSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], EllipseSettingModalComponent.prototype, "viewHeight", void 0);
    EllipseSettingModalComponent = __decorate([
        Component({
            selector: 'ellipse-setting-modal',
            styles: [".configure { .form-label { width: 80px; } .checkbox { padding-left: 20px; margin-bottom: 0px; } .settingTool { .inline-control-input { width: 100px; display: inline-block; } } .float-left { float: left; } .sharpFill { margin: 5px 0 0 5px; } .strokColor { margin: 5px 0 0 3px; } } .color-picker{ width: 100px; } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"ellipseSettingModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" (onHidden)=\"onHidden()\"> <div class=\"modal-dialog\" style=\"min-width: 600px;\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <form class=\"configure ellipse\" *ngIf=\"active\" #pipeSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Ellipse\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"SharpFill\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"fill\" (sentColor)=\"setFillColor($event)\"></color-picker> </div> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"StrokColor\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"stroke\" (sentColor)=\"setStrokeColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"StrokWidth\")}}:</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"strokeWidth\" [(ngModel)]='strokeWidth' min=\"0\" /> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"SharpWidth\")}}:</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"width\" [(ngModel)]='width' min=\"0\" /> </div> <div class=\"fe-half-line float-left margin-top-10\"> <label class=\"fe-transverse-title\">{{lc(\"SharpHight\")}}:</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"height\" [(ngModel)]='height' min=\"0\" /> </div> </div> </div> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true' [isSizeEnable]='false'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!pipeSettingForm.form.valid || dynamicValidatoinResult\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], EllipseSettingModalComponent);
    return EllipseSettingModalComponent;
}(ElementSettingModalBase));
export { EllipseSettingModalComponent };
